import React from 'react'
import { useNavigate } from 'react-router'
import { Card, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLayerGroup,
  faUsers,
  faPlus,
  faGear,
} from '@fortawesome/free-solid-svg-icons'
import { useGetGrowthWheelEditorSummariesQuery } from '../../redux/growth-wheel.endpoints'
import { GrowthWheelSummary } from '../../types/GrowthWheel'
import '../../css/growthWheel.scss'

const GrowthWheelEditorLanding = () => {
  const {
    data: wheels,
    isLoading,
    isError,
  } = useGetGrowthWheelEditorSummariesQuery()
  const navigate = useNavigate()

  const handleEditWheel = (wheel: GrowthWheelSummary) => {
    navigate(`/edit-growth-wheel/${wheel.id}`)
  }

  if (isLoading) {
    return (
      <div className="gw-editor-landing">
        <div className="gw-editor-landing-loader">
          <Spinner animation="border" role="status" variant="secondary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="gw-editor-landing">
        <div className="gw-editor-landing-empty">
          <p className="gw-editor-landing-empty-title">
            Unable to load Growth Wheels
          </p>
          <p className="gw-editor-landing-empty-text">
            Please try again later or contact an administrator.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="gw-editor-landing">
      {/* Header */}
      <div className="gw-editor-landing-header">
        <div>
          <h1 className="gw-editor-landing-title">Growth Wheel Management</h1>
          <p className="gw-editor-landing-subtitle">
            Select a role to configure its competency framework and growth wheel
            structure.
          </p>
        </div>
        <button className="gw-editor-landing-add-btn">
          <FontAwesomeIcon icon={faPlus} />
          Add Growth Wheel
        </button>
      </div>

      {/* Empty State */}
      {!wheels || wheels.length === 0 ? (
        <div className="gw-editor-landing-empty">
          <div className="gw-editor-landing-empty-icon">
            <FontAwesomeIcon icon={faLayerGroup} />
          </div>
          <h2 className="gw-editor-landing-empty-title">
            No Growth Wheels yet
          </h2>
          <p className="gw-editor-landing-empty-text">
            Add a Growth Wheel for a role to start building its competency
            framework.
          </p>
          <button className="gw-editor-landing-add-btn">
            Add First Growth Wheel
          </button>
        </div>
      ) : (
        /* Roles Grid */
        <div className="gw-editor-landing-grid">
          {wheels.map(wheel => {
            const areas = wheel.competencyAreasCount
            const subs = wheel.competenciesCount

            return (
              <Card key={wheel.id} className="gw-editor-wheel-card">
                <button
                  className="gw-editor-wheel-card-main"
                  onClick={() => handleEditWheel(wheel)}
                >
                  <h3 className="gw-editor-wheel-card-title">
                    {wheel.roleName}
                  </h3>

                  {/* Stats */}
                  <div className="gw-editor-wheel-card-stats">
                    <div className="gw-editor-wheel-card-stat">
                      <FontAwesomeIcon
                        icon={faLayerGroup}
                        className="gw-editor-wheel-card-stat-icon"
                      />
                      <span>
                        {areas} {areas === 1 ? 'competency' : 'competencies'},{' '}
                        {subs}{' '}
                        {subs === 1 ? 'sub-competency' : 'sub-competencies'}
                      </span>
                    </div>
                  </div>

                  {/* Contributor Count */}
                  <div className="gw-editor-wheel-card-contributors">
                    <FontAwesomeIcon icon={faUsers} />
                    <span>
                      {wheel.contributorsCount}{' '}
                      {wheel.contributorsCount === 1
                        ? 'contributor'
                        : 'contributors'}
                    </span>
                  </div>
                </button>
              </Card>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default GrowthWheelEditorLanding
